//import CONFIG from '../config';

import { Injectable } from '@angular/core';
import { BackendService } from '../shared/backend.service';
//import { NotificationService } from '../notification.service';
import CONFIG from 'src/config';

import { map } from 'rxjs/operators';
import {Observable} from 'rxjs/Rx';
import { NotificationService } from '../notification.service';
import { PopupdisplayComponent } from '../popupdisplay/popupdisplay.component';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';

@Injectable()
export class ResetFormService {
    forgotPasswordShow: boolean = false;
    validEmail: boolean = false;
    otpvalid:boolean=false;
    otpvalidsuccess:boolean=false;
    emailPending: boolean = false;
    validAnswer: boolean = false;
    emailhide:boolean = false;
    pwd_reset_q1: string = '';
    pwd_reset_q2: string = '';
    questions: string[] = [];
    selectedQuestion: number = 0;
    dialogRef: MatDialogRef<PopupdisplayComponent>;
     //index of questions array of selected question

    constructor(public _backendService: BackendService, 
            public _notificationService: NotificationService,
            public _router: Router,
            public _authService: AuthService,
            ) {}

    forgottenPasswordFormUpdate(status: boolean, $event?: any) {
        ////console.log(status,event);
       //// console.log("test");
        if($event) { $event.preventDefault(); };
        ////console.log("tets if");
        this.validEmail = false;
        this.validAnswer = false;
        this.forgotPasswordShow = status;
        this.otpvalidsuccess=false;
        this.otpvalid=false;
        this.emailhide=false;
        let currentUrl = 'login';
      this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this._router.navigate([currentUrl]);
      });
    }

    switchQuestion() {
        this.selectedQuestion = this.selectedQuestion === 0 ? 1 : 0;
    }

    submitEmail(email: string) {
       //// console.log(email);
        this.emailPending = true;
        this._backendService.postData(email, `${CONFIG.sendemailApiUrlBase}/checkcustomer`)
            .subscribe(response => {
                ////console.log(response);
                this.emailPending = false;
                if(response['result']) {
                    //if user hasn't set reset questions yet, don't allow
                    if(!response || !response) {
                        this._notificationService.showNotification({ 
                            message: 'No password reset questions are on file for your login - Please contact your site administrator to reset your password.', 
                            type: 'error' 
                        });
                        this.forgotPasswordShow = false;
                        return;
                    }
                    this.questions.push(response['pwd_reset_q1'],response['pwd_reset_q2']);
                    this._notificationService.showNotification({ type: 'success', message:response['msg']});
                    console.log(response['pwd_reset_q1'],response['pwd_reset_q2']);
                    this.validEmail = true;
                    this.otpvalid=true
                    this.emailhide=true
                } else {
                    this._notificationService.showNotification({ message: 'Invalid CustomerID', type: 'error' });
                    this.validEmail = false;
                    this.otpvalid=false
                    this.emailhide=false
                }
            });
    }

    OTPValidate(email: any) {
         console.log(email);
         this.emailPending = true;
         this._backendService.postData(email, `${CONFIG.sendemailApiUrlBase}/otpvalidate`)
             .subscribe(response => {
                debugger 
                console.log(response);
                 this.emailPending = false;
                 if(response['result']) {
                     //if user hasn't set reset questions yet, don't allow
                    //  if(!response || !response) {
                    //      this._notificationService.showNotification({ 
                    //          message: 'No password reset questions are on file for your login - Please contact your site administrator to reset your password.', 
                    //          type: 'error' 
                    //      });
                    //      this.forgotPasswordShow = false;
                    //      return;
                    //  }
                 //    this.questions.push(response['pwd_reset_q1'],response['pwd_reset_q2']);
                     //this._notificationService.showNotification({ type: 'success', message:response['msg']});
                   //  console.log(response['pwd_reset_q1'],response['pwd_reset_q2']);
                     //this.validEmail = true;
                     //-------- redirecting to rest password page ------//
                     this._authService.loggedIn = true;

            sessionStorage.setItem('NIBNumber', response['nibnumber']);
            this._authService.NIBNumber = sessionStorage.getItem('NIBNumber');   
            ////console.log(this._authService.NIBNumber)                  ;

            sessionStorage.setItem('token', response['token']);
            this._authService.token = sessionStorage.getItem('token'); 
              this._notificationService.showNotification({ type: 'warning', message: 'Please reset your password' });
              this._router.navigate(['/profile']);
           
                    //  this.otpvalid=false
                    //  this.otpvalidsuccess=true
                    //  this.emailhide=false;
                     
                 } else {
                     this._notificationService.showNotification({ message: 'Invalid one-time password', type: 'error' });
                    // this.validEmail = false;
                     this.otpvalid=true
                     this.otpvalidsuccess=false
                     this.emailhide=true;
                 }
             });
     }

    submitAnswer(answerObj: Object) {
        //add the text of the selected question to the object sent to the server
        answerObj['Question'] = this.questions[this.selectedQuestion];

         return this._backendService.postData(answerObj,`${CONFIG.sendemailApiUrlBase}/email`).map(response =>{
             return response;
         })
    }

    disableUser(email: string) {
        this._backendService.postData(email, `${CONFIG.usersApiUrlBase}/disableuser`)
            .subscribe(response => {
                this._notificationService.showNotification({ message: response['msg'], type: 'success' });
            }, error => {
                this._notificationService.showNotification({ message: error.msg, type: 'error' });
            });
    }
}